import { render, staticRenderFns } from "./BinFillIcon.vue?vue&type=template&id=93821f0c&"
import script from "./BinFillIcon.vue?vue&type=script&lang=js&"
export * from "./BinFillIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports